import React from 'react';
import classes from './LoadingSpinner.module.css';

const LoadingSpinner = () => {
  return (
    <div className={classes.loading_spinner_container}>
      <div className={classes.lds_dual_ring}></div>
    </div>
  );
};

export default LoadingSpinner;